import { checkboxAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys)

const baseStyle = definePartsStyle({
  icon: {
    color: 'white',
  },
  control: {
    size: 5,
    border: '0',
    borderRadius: 'base',
    background: '#45454559',
    _checked: {
      background: 'black',
      _hover: {
        background: 'black',
      },
    },
  },
})

const ghost = definePartsStyle({
  icon: {
    color: 'black',
  },
  control: {
    border: '0',
    borderRadius: 'base',
    background: 'none',
    _checked: {
      background: 'none',
      _hover: {
        background: 'none',
      },
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
  },
})

const md = definePartsStyle({
  control: defineStyle({
    boxSize: 5,
  }),
})

export const checkboxTheme = defineMultiStyleConfig({
  baseStyle,
  variants: { ghost },
  sizes: { md },
})
